export default [
	{
		path: "/admin/faq",
		exact: true,
		policy: "writerAdminAuth",
		component: "AdminFAQ",
		mui: true,
	},
];
